import React from 'react';

import DefaultLayout from '../layouts/DefaultLayout';
import WorkHero from '../components/ui/WorkHero.js';
import LetsBuildTogether from '../components/ui/LetsBuildTogether';

const WorkPage = () => (
  <DefaultLayout>
    <WorkHero />
    <LetsBuildTogether />
  </DefaultLayout>
);

export default WorkPage;



// WEBPACK FOOTER //
// ./src/pages/WorkPage.js